import React from 'react';
import Icon from '../../../components/AppIcon';

const PerformanceMetricsGrid = ({ metrics }) => {
  const getProgressColor = (value, target, unit) => {
    const percentage = unit === 'seconds' || unit === 'minutes' ? (target / value) * 100 : (value / target) * 100;
    if (percentage >= 100) return 'bg-success';
    if (percentage >= 80) return 'bg-primary';
    if (percentage >= 60) return 'bg-warning';
    return 'bg-error';
  };

  const formatValue = (value, unit) => {
    if (unit === 'percentage') return `${value}%`;
    if (unit === 'rating') return `${value}/5`;
    if (unit === 'seconds') return `${value}s`;
    if (unit === 'minutes') return `${value}m`;
    return value;
  };

  const getProgressPercentage = (value, target, unit) => {
    if (unit === 'seconds' || unit === 'minutes') {
      return Math.min((target / value) * 100, 100);
    }
    return Math.min((value / target) * 100, 100);
  };

  return (
    <div className="card">
      <h2 className="text-2xl font-heading font-semibold text-foreground mb-6">
        Role-Based Performance Indicators
      </h2>
      <div className="space-y-6">
        {metrics?.map((category, idx) => (
          <div key={idx} className="bg-muted/50 rounded-lg p-6">
            <h3 className="text-lg font-semibold text-foreground mb-4 flex items-center gap-2">
              <Icon name="Target" size={20} color="var(--color-primary)" />
              {category?.category}
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
              {category?.metrics?.map((metric, metricIdx) => (
                <div key={metricIdx} className="bg-card rounded-lg p-4">
                  <div className="text-sm text-muted-foreground mb-2">{metric?.label}</div>
                  <div className="text-2xl font-semibold text-foreground mb-1 data-text">
                    {formatValue(metric?.value, metric?.unit)}
                  </div>
                  <div className="text-xs text-muted-foreground mb-3">
                    Target: {formatValue(metric?.target, metric?.unit)}
                  </div>
                  <div className="w-full h-2 bg-muted rounded-full overflow-hidden">
                    <div
                      className={`h-full transition-all duration-500 ${
                        getProgressColor(metric?.value, metric?.target, metric?.unit)
                      }`}
                      style={{ width: `${getProgressPercentage(metric?.value, metric?.target, metric?.unit)}%` }}
                    ></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PerformanceMetricsGrid;